import React from 'react';

interface PaperSectionProps {
  paperUrl: string;
  title?: string;
  description?: string;
  buttonText?: string;
}

const PaperSection: React.FC<PaperSectionProps> = ({
  paperUrl,
  title = 'Paper',
  description = 'Discover the full details of the FoMo dataset in our research paper.',
  buttonText = 'Download PDF',
}) => {
  return (
    <section className="py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="text-4xl text-center font-extrabold tracking-tight mb-6">
          {title}
        </h2>
        <p className="text-lg text-gray-700 dark:text-gray-300 mb-8">
          {description}
        </p>
        <a
          href={paperUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center px-6 py-3 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-lg shadow-sm transition-colors"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-5 w-5 mr-2"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
            />
          </svg>
          {buttonText}
        </a>
      </div>
    </section>
  );
};

export default PaperSection;
